import { formatDateStr } from "src/utils/DateUtil";
import { HttpMethod } from "../types/HttpMethod";

const apiUrl = `${process.env.REACT_APP_BASE_URL}/rs/automation/process`;

export const downloadserverreport = (
  auth: string,
  folderName: number,
  reportUser: string,
  productCode: string,
  clientCode: string
) => {
  const url = `${apiUrl}/${productCode}/downloadReport?folderName=${folderName}&reportUser=${reportUser}&clientCode=${clientCode}`;
  return fetch(url, {
    method: HttpMethod.Get,
    headers: {
      Authorization: auth,
    },
  });
};

export const getreportsummarydatafrmdb = (auth: string, filterdata: any) => {
  const url = `${apiUrl}/reports`;
  const filterKeys = [
    "runId",
    "reportStartDate",
    "reportEndDate",
    "countryCode",
    "status",
    "reportUser",
    "productCode",
    "clientCode",
    "scheduleJobId",
  ];

  const data = filterKeys.reduce((key: any, value: any) => {
    if (filterdata[value]) {
      if (value === "reportStartDate" || value === "reportEndDate") {
        key[value] = [
          formatDateStr(
            new Date(filterdata[value]),
            "YYYY-MM-DD HH:mm:ss",
            false
          ),
        ];
      } else {
        key[value] = [filterdata[value]];
      }
    }
    return key;
  }, {});
  return fetch(url, {
    method: HttpMethod.Post,
    headers: { Authorization: auth, "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
};

export const checkinprogressrecords = (auth: string, username: string, clientCode: string) => {
  let url = `${apiUrl}/checkInProgressRecords?username=${username}&clientCode=${clientCode}`;
  return fetch(url, {
    method: HttpMethod.Get,
    headers: { Authorization: auth },
  });
};

export const runautomation = (
  auth: string,
  formData: FormData,
  productCode: string,
  clientCode: String
) => {
  const url = `${apiUrl}/${productCode}/run?clientCode=${clientCode}`;
  return fetch(url, {
    method: HttpMethod.Post,
    headers: {
      Authorization: auth,
    },
    body: formData,
  });
};
